import {Injectable} from '@angular/core';
import { A48ReportTypes } from 'src/app/enums/reports/reports.enum';
import { CplA48ParaReportRequest } from 'src/app/model/cpl-a48-para-report-reqest.model';
import { A48CourseTypes } from 'src/app/model/enum/a48-sub-type.enum';
import { DateHelpers } from '@edl-development/edl-common';
import { SchoolYearSchedule } from 'src/app/model/school-year-schedule';
import { A48ReportPerms } from 'src/app/enums/reports/a48-report-perms.enum';
import { CplItemSubType } from 'src/app/model/enum/cpl-item-sub-type.enum';

@Injectable()
export class Act48ReportHelpersService {
    a48CourseTypes = new A48CourseTypes();

    getReportRequest = ({ 
        userID, 
        startDate, 
        endDate, 
        type, 
        perms,
        itemSubType,
        showDetails, 
        showUserPicker, 
        shouldGetAll, 
        page,
        limit
    }: {
        userID?: string, 
        startDate?: string, 
        endDate?: string, 
        type?: A48ReportTypes, 
        perms?: A48ReportPerms,
        itemSubType?: CplItemSubType,
        showDetails?: boolean | string, 
        showUserPicker?: boolean | string, 
        shouldGetAll?: boolean,
        page?: number,
        limit?: number
    }) => {
        const request = new CplA48ParaReportRequest();
        const currentSchoolyear = new SchoolYearSchedule();
        request.StartDate = DateHelpers.shortDateStringToDate(startDate ?? currentSchoolyear.StartDate);
        request.EndDate = DateHelpers.shortDateStringToDate(endDate ?? currentSchoolyear.EndDate);
        request.UserID = userID;
        request.Type = type ?? A48ReportTypes.PARAEDUCATOR;
        request.Perms = perms ?? A48ReportPerms.ALL;
        request.ItemSubType = itemSubType;
        request.ShowDetails = (showDetails === 'false' || showDetails === false) ? false : true;
        request.ShowUserPicker = (showUserPicker === 'false' || showUserPicker === false) ? false : true;
        request.ShouldGetAll = shouldGetAll;
        request.Offset = !shouldGetAll ? (page - 1) * limit : 0;
        request.Limit = limit ?? -1;

        return request;
    }

    getCecPerformanceStandard = (cecPerformanceId: number) => {
        const cecPerformance = this.a48CourseTypes.cecPerformance.filter(x => x.id == cecPerformanceId);
        return cecPerformance && cecPerformance.length > 0 ? cecPerformance[0].name : '';
    }

    getTitle = (type: A48ReportTypes, subType: CplItemSubType) => {
        const roleName = this.getRoleName(type);

        switch(subType) {
            case CplItemSubType.FLEX:
                return `${roleName} Flex Report`;
            case CplItemSubType.CLEARANCE:
                return `${roleName} Clearance Report`;
            default: 
                return `Act 48 ${roleName} Report`;
        }
    }

    private getRoleName = (type: A48ReportTypes) => {
        switch(type) {
            case A48ReportTypes.EMERGENCY_CERTIFIED:
                return 'Emergency Cert';
            case A48ReportTypes.PARAEDUCATOR:
                return 'Paraeducator';
            default: 
                return 'Teacher';
        }
    }
}